import React, { useState } from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GeckoAlert } from '../../../ui';
import { GeckoFields } from '../../../ui';
import { useSelector } from 'react-redux';
import TagSelect from 'components/TagSelect';

const AddMassTagsModal = ({ setActionTimestamp, massAction }) => {
  const [tagIdsToAssign, setTagIdsToAssign] = useState([]);

  const [actionTriggered, setActionTriggered] = useState(false);

  const tags = useSelector((state) => state.tags);

  const field = () => {
    return [
      {
        key: 'value',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        options: tags.map((tag) => {
          return { label: tag.name, value: tag.id };
        }),
        component: (
          <TagSelect
            value={values}
            multi
            create
            config={{
              autoFocus: true,
              openOnFocus: true,
            }}
          />
        ),
        width: '100',
      },
    ];
  };

  const values = { value: tagIdsToAssign };

  const handleChange = (_key, value) => {
    setTagIdsToAssign(value);
  };

  const pluralize = (word, count) => {
    return count === 1 ? word : word + 's';
  };

  return (
    <GeckoModal
      name="Add tags"
      children={
        <>
          {!actionTriggered ? (
            <GeckoFields
              fields={field()}
              values={values}
              handler={handleChange}
            />
          ) : null}

          <div>
            <GeckoAlert type={'warning'}>
              {actionTriggered
                ? `${tagIdsToAssign.length} ${pluralize(
                    'tag',
                    tagIdsToAssign.length
                  )} being`
                : `These tags will be`}{' '}
              added to {massAction.selected.length}{' '}
              {pluralize('conversation', massAction.selected.length)}.
            </GeckoAlert>
          </div>
        </>
      }
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'fa fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
          hideWhen: () => {
            return actionTriggered;
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: actionTriggered ? 'Adding' : 'Done',
          icon: actionTriggered ? 'far fa-spinner spin' : 'far fa-check-double',
          disabledWhen: () => {
            return (
              !tagIdsToAssign.length ||
              !massAction.selected.length ||
              actionTriggered
            );
          },
          handler: () => {
            setActionTriggered(true);
            GeckoRequest.post(`/tags/mass-conversation-tags`, {
              conversationIds: massAction.selected,
              tagIds: tagIdsToAssign,
            })
              .then(() => {
                new GeckoModalService().close();
                new GeckoToastService().success(
                  'Mass tags assignment complete'
                );
                setActionTriggered(false);
                setActionTimestamp(Date.now());
              })
              .catch((err) => {
                new GeckoModalService().close();
                setActionTriggered(false);
                new GeckoToastService().error(
                  'Mass tags assignment failed. Please try again. If the problem persists please contact support.'
                );
              });
          },
        },
      ]}
    />
  );
};

export default AddMassTagsModal;
